import React, { useId } from 'react';
import { twJoin } from 'tailwind-merge';
import { useTranslations } from 'next-intl';
import OptimizedImage from '@/ui/components/shared/OptimizedImage';
import { getOptionTileStateClasses } from '@/ui/components/shared/option-tile/option-tile-styles';
import { CylinderDetail } from '@/ui/components/pages/ProductDetail/SmartlockDetail/types/CylinderDetail';

export interface CylinderOptionProps {
  cylinder: CylinderDetail;
  isSelected: boolean;
  onSelect: () => void;
}

export function CylinderOption({ cylinder, isSelected, onSelect }: Readonly<CylinderOptionProps>) {
  const t = useTranslations('CylinderOption');
  const nameId = useId();
  // All tiles share the generic label, so the visible name tells them apart when there is one.
  const hasName = cylinder.name.trim().length > 0;

  return (
    <div className="w-1/2 items-center justify-center">
      <button
        type="button"
        onClick={onSelect}
        className={twJoin('flex w-full rounded-md p-6', getOptionTileStateClasses(isSelected))}
        aria-label={t('Select cylinder')}
        aria-labelledby={hasName ? nameId : undefined}
        aria-pressed={isSelected}
      >
        <OptimizedImage
          image={cylinder.image}
          sizes="100px"
          width={48}
          height={48}
          className="mx-auto h-12 rounded-full"
        />
      </button>
      <div id={nameId} className="mt-2 text-center font-bold">
        {cylinder.name}
      </div>
    </div>
  );
}
